import React, { useEffect, useState } from 'react'
import Applications from './application-section/Applications'
import Visit from './visit-section/Visit'
import PerfectSlabSection from './perfect-slab-section/PerfectSlabSection'
import BannerSection from './banner-section/BannerSection'
import Benefits from './benefits-section/Benefits'
import NewArrivals from './new-arrivals/NewArrivals'
import OutletSection from './outlet-section/OutletSection'
import VisitLite from './visit-section-lite/VisitLite'
import { connect } from 'react-redux'
import { fetchBannerProducts, fetchNewest, fetchOutlet, fetchPerfectSlabs } from '../../store/natural-stone/actions'
import {
    getBannerProducts,
    getIsLoadingBannerProduct,
    getIsLoadingNewestColors,
    getIsLoadingOutletProduct,
    getIsLoadingPerfectSlabs,
    getNewestColors,
    getOutletProducts,
    getPerfectSlab
} from '../../store/natural-stone/reducers'
import { injectIntl } from 'react-intl'
import { getLanguage, getLanguageDir, getShowOnlineVisitBanner } from '../../store/ui/reducers'
import { getHQCenterId } from '../../store/centers/reducers'
import {
    getCommonParams,
    getOnlineVisitUrl,
    getPriceListAtSelectedCenter,
    getUserPriceList
} from '../../store/login/reducers'
import styles from './style/natural_stone_style.module.scss'
import * as analytics from '../../analyticsEvents'
import { fetchProductsDiscounts } from '../../store/products/actions'


const NaturalStoneScreen = (props)=> {

    const observers = []
    const analyticsTag = {
        PN_BANNER: {
            hasObserver: false,
            sent: false
        },
        PN_PERFECT_SLAB: {
            hasObserver: false,
            sent: false
        },
        PN_NEW_ARRIVALS: {
            hasObserver: false,
            sent: false
        },
        PN_OUTLET: {
            hasObserver: false,
            sent: false
        },
    }

    const updateSection = (tag, products) => {
        if (!analyticsTag[tag].hasObserver && products && products.length > 0) {
            analyticsTag[tag].products = products
            analyticsTag[tag].hasObserver = true
            const observer = createObserver(tag, analyticsTag[tag], props)
            if (observer) observers.push(observer)
        }
    }

    useEffect(() => {
        props.setIsInOutletSpain()
        props.fetchProductsDiscounts()

        return () => {
            observers.forEach(observer => observer.disconnect())
        }
    }, [])

    return (
        <div className={styles['natural-stone']}>
            <BannerSection id='PN_BANNER' updateSection={updateSection} {...props} />
            <div className={styles['natural-stone-content']}>
                <PerfectSlabSection id='PN_PERFECT_SLAB' updateSection={updateSection} {...props} />
                <NewArrivals id='PN_NEW_ARRIVALS' updateSection={updateSection} {...props} />
                {props.canSeeVirtualVisit && <VisitLite url={props.onlineVisitUrl}/>}
                <OutletSection id='PN_OUTLET' updateSection={updateSection} {...props} />
                <Applications {...props} />
                <Benefits />
                {props.canSeeVirtualVisit && <Visit url={props.onlineVisitUrl}/>}
            </div>
        </div>
    )
}

const createObserver = (tag, data, props) => {
    const options = {
        root: null, // Means browser viewport reference
        rootMargin: "0px", // Means 100% of the viewport
        threshold: 0.8 // Means 100% of the element
    }

    const el = document.getElementById(tag)

    if (el) {
        const observer = new IntersectionObserver(handleIntersect(tag, data, props), options)
        observer.observe(el)
        return observer
    }
}

const handleIntersect = (tag, data, props) => (entries) => {
    if (!data.sent) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                analytics.sendCatalogImpressions(data.products, tag, props.priceList, props.userPriceList, props.commonParamsAnalytics)
                data.sent = true
            }
        })
    }
}

const mapStateToProps = (state) => {
    return {
        perfectSlabs: getPerfectSlab(state),
        newestColors: getNewestColors(state),
        outletProducts: getOutletProducts(state),
        bannerProducts: getBannerProducts(state),
        loadingPerfectSlabs: getIsLoadingPerfectSlabs(state),
        loadingNewestColors: getIsLoadingNewestColors(state),
        loadingOutletProduct: getIsLoadingOutletProduct(state),
        loadingBannerProduct: getIsLoadingBannerProduct(state),
        lang: getLanguage(state),
        centerId: getHQCenterId(state),
        canSeeVirtualVisit: getShowOnlineVisitBanner(state),
        onlineVisitUrl: getOnlineVisitUrl(state),
        commonParamsAnalytics: getCommonParams(state),
        priceList: getPriceListAtSelectedCenter(state),
        userPriceList: getUserPriceList(state),
        languageDir: getLanguageDir(state)
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        fetchBannerProducts: () => {
            dispatch(fetchBannerProducts())
        },
        fetchPerfectSlabs: family => {
            dispatch(fetchPerfectSlabs(family))
        },
        fetchNewest: () => {
            dispatch(fetchNewest())
        },
        fetchOutlet: () => {
            dispatch(fetchOutlet())
        },
        fetchProductsDiscounts: () => dispatch(fetchProductsDiscounts()),
        setIsInOutletSpain: () => dispatch({type:'SET_IS_IN_OUTLET_SPAIN', isInOutletSpain: true}),
        // click: (product, list, index) => dispatch({ type: 'PRODUCT_CLICK', product, index, list})
    }
}

export default injectIntl(connect(
    mapStateToProps,
    mapDispatchToProps
)(NaturalStoneScreen))
